<template>
  <md-dialog
    id="modFileUploadComponents"
    ref="moduleModal"
    md-title
    :md-esc-to-close="false"
    :md-click-outside-to-close="false"
    class="dashboard modals"
  >
    <md-dialog-title>
      <span>Upload de Arquivo</span>
      <button
        id="mod_btnClose"
        class="close-button btn-transparent"
        @click="closeDialog"
      >
        <md-icon>clear</md-icon>
      </button>
    </md-dialog-title>

    <md-dialog-content>
      <component
        :is="'upload-file'"
        @closeModalContainer="closeDialog"
      />
    </md-dialog-content>
  </md-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UploadFile from './UploadFile'

export default {
  name: 'UploadFileModal',
  components: {
    'upload-file': UploadFile
  },
  data () {
    return {
      resetModal: true
    }
  },
  methods: {
    ...mapActions(['setUploadFileModalVisible']),
    ...mapActions(['setInitialUploadFileStatus']),
    ...mapActions(['setuploadFileStatusMessage']),
    openDialog () {
      this.$refs.moduleModal.open()
      this.$analytics.pushAnalyticsEvent('vpageview', {
        page: 'modal/upload-file',
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName
      })
    },
    closeDialog () {
      this.setUploadFileModalVisible(false)
      this.setuploadFileStatusMessage(null)
      this.$refs.moduleModal.close()
    }
  },
  watch: {
    isUploadFileModalVisible () {
      if (this.isUploadFileModalVisible) {
        this.openDialog()
      } else {
        this.closeDialog()
      }
    }
  },
  computed: {
    ...mapGetters(['profile']),
    ...mapGetters(['isUploadFileModalVisible'])
  }
}
</script>

<style>
.dashboard.modals .md-dialog {
  min-width: 660px;
  min-height: 480px;
}
</style>
